<template>
  <v-alert v-if="show"
           elevation="2"
           color="error"
           text
           outlined
           icon="mdi-alert-circle">
    <div class="font-weight-medium" style="font-size:1.1rem;line-height:1.5">
      {{ $t('page.manageFiling.invalidFilingType.title') }}
    </div>
    <div class="mt-2">
      {{ $t('page.manageFiling.invalidFilingType.description') }}
    </div>
    <div class="text-right mt-2">
      <c-btn type="danger" @click="$emit('removeFiling');">
        {{ $t('page.manageFiling.sidebar.removeFiling') }}
      </c-btn>
    </div>
  </v-alert>
</template>

<script>
import { useFilingStore } from '@/stores/filingStore';

const filingStore = useFilingStore();

export default {
  computed: {
    show () {
      return filingStore.invalidFilingType;
    }
  }
};
</script>